import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("img", {
      src: _ctx.getIcon,
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args))),
      class: "icon",
      alt: "Remove File"
    }, null, 8, _hoisted_3)
  ]))
}